import { lazy } from "react";
import { Droplet } from "lucide-react";

import type { FeatureDescriptor } from "@/features/types";

export const consumptionFeature: FeatureDescriptor = {
  id: "consumption",
  flag: "consumption",
  path: "/consumption",
  group: "operate",
  navKey: "nav.consumption",
  icon: Droplet,
  element: lazy(() => import("./ConsumptionPage")),
  scope: { locality: true, days: true },
};
